import { useEffect } from 'react';
import { resumeAudio } from '@/lib/webAudio';
import { RINGTONE_IDS, startRingtone } from '@/lib/sounds';

/* The ids are stored per user (`call_settings.ringtone`); what they SOUND like
   lives with every other sound, in lib/sounds.ts. */
export const RINGTONE_OPTIONS: readonly string[] = RINGTONE_IDS;

/**
 * Rings while `active`, with the tone the CALLEE chose.
 *
 * An unknown name falls back to `default` rather than to silence: a ringtone
 * this build has never heard of must still make the phone ring.
 */
export function useRingtone(active: boolean, ringtone = 'default'): void {
  useEffect(() => {
    if (!active) return undefined;
    const stop = startRingtone(ringtone);
    /* Autoplay policy: if the context was blocked, the first gesture unblocks it. */
    const unlock = (): void => resumeAudio();
    window.addEventListener('pointerdown', unlock, { once: true, passive: true });
    window.addEventListener('keydown', unlock, { once: true });
    return () => {
      stop();
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, [active, ringtone]);
}
